export default "__VITE_ASSET__DxGG90o0__"